import { render, staticRenderFns } from "./AccessAdd.vue?vue&type=template&id=720a84d2"
import script from "./AccessAdd.vue?vue&type=script&lang=js"
export * from "./AccessAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports